import { createContext } from 'react'
import { GridSize, GridSpacing } from '@mui/material'

export interface GridContextProps {
  gridSpacing: GridSpacing
  defaultColWidth: GridSize
  defaultRowSpacingHorizontal?: GridSpacing
}

export const GridContext = createContext<GridContextProps>({
  gridSpacing: 3,
  defaultColWidth: 6,
})
